import { useContext, useState } from 'react';
import { Box, Checkbox, Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { DropsContext } from 'contexts/DropsContext';
import { ProdutosContext } from 'contexts/ProdutosContext';
import VirtualDrop from 'components/VirtualDrop';
import Container from 'components/Container';
import Header from 'components/Header';
import Button from 'components/Button';
import Input from 'components/Input';
import Card from 'components/Card';
import api from 'services/api';
import { TreeItem, TreeView } from '@mui/x-tree-view';
import { ArrowDropDown, ArrowRight } from '@mui/icons-material';

const Manutenção = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const defaultValues = {
    id,
    integra_access_id: null,
    produto_id: null,
    titulo: '',
    observacao: '',
    categoria_id: null,
  };
  const [categorias, setCategorias] = useState([]);
  const { drops } = useContext(DropsContext);
  const { postLoading, postIntegracao } = useContext(ProdutosContext);
  const { control, watch, setValue, handleSubmit } = useForm({ defaultValues });
  const height = '75vh';

  const getCategorias = async (values) => {
    if (values?.value) {
      const params = { integra_access_id: values?.value };
      const { data } = await api.get(`Integracoes/Mercos/Envio`, { params });
      setCategorias(data);
    }
  };

  const onSubmit = (data) =>
    postIntegracao({
      data,
      path: 'Mercos/Anuncio',
      cb: () => navigate(-1),
    });

  const renderTree = (nodes) => (
    <TreeItem
      key={`${nodes?.id}`}
      nodeId={`${nodes?.id}`}
      label={
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {!Array.isArray(nodes?.children) && (
            <Checkbox
              size="small"
              checked={nodes?.id === watch('categoria_id')}
              onChange={(_, v) => {
                if (v) {
                  setValue('categoria_id', nodes?.id);
                } else {
                  setValue('categoria_id', null);
                }
              }}
            />
          )}
          <Typography sx={{ fontWeight: 'bold', py: '6px', ml: 1 }}>
            {nodes?.nome}
          </Typography>
        </Box>
      }
    >
      {Array.isArray(nodes?.children) ? nodes?.children?.map(renderTree) : null}
    </TreeItem>
  );

  return (
    <Container>
      <Header titulo={Boolean(id) ? 'Editar Anúncio' : 'Cadastrar Anúncio'} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Card title="Informações gerais" style={{ height }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <VirtualDrop
                  name="produto_id"
                  control={control}
                  label="Produto"
                  options={drops?.Produto}
                  onValueChange={(v) => setValue('titulo', v?.label || '')}
                />
              </Grid>
              <Grid item xs={12}>
                <Input name="titulo" control={control} label="Título" />
              </Grid>
              <Grid item xs={12}>
                <VirtualDrop
                  name="integra_access_id"
                  control={control}
                  label="Conta"
                  options={drops?.IntegraAccess?.filter(
                    (f) => f?.label === 'MERCOS'
                  )}
                  onValueChange={(v) => getCategorias(v)}
                />
              </Grid>
              <Grid item xs={12}>
                <Input
                  name="observacao"
                  control={control}
                  label="Observação"
                  multiline
                  rows={10}
                />
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card title="Categorias" style={{ height, overflowY: 'auto' }}>
            {categorias?.length > 0 ? (
              <TreeView
                defaultCollapseIcon={<ArrowDropDown />}
                defaultExpandIcon={<ArrowRight />}
              >
                {categorias?.map(renderTree)}
              </TreeView>
            ) : (
              <Typography variant="caption" alignSelf="center">
                Selecione a conta para carregar as categorias
              </Typography>
            )}
          </Card>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onSubmit)}
            loading={postLoading}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Manutenção;
